import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/home/index.vue"),
  },
  {
    path: "/study",
    name: "Study",
    component: () => import("../views/study/index.vue"),
  },
  {
    path: "/practice",
    name: "Practice",
    component: () => import("../views/practice/index.vue"),
  },
  {
    path: "/mock-examination",
    name: "MockExamination",
    component: () => import("../views/mock-examination/index.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/computer-maintenance-worker/",
  routes,
});

export default router;
